import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bcd226ee")

_pushScopeId("data-v-bcd226ee")
const _hoisted_1 = { class: "schedule-import__container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "schedule-import__rule" }, "Équipes manquantes", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "schedule-import__rule" }, "Terrains manquants", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "schedule-import__rule" }, "Match entrant en conflit", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _hoisted_2,
      _createVNode("span", {
        title: _ctx.report.missingTeams.join(', '),
        class: ["badge badge--rounded", {
                    'badge--warning': _ctx.report.missingTeams.length,
                    'badge--success': !_ctx.report.missingTeams.length
                }]
      }, _toDisplayString(_ctx.report.missingTeams.length), 11, ["title"])
    ]),
    _createVNode("div", null, [
      _hoisted_3,
      _createVNode("span", {
        title: _ctx.report.missingFields.join(', '),
        class: ["badge badge--rounded", {
                    'badge--warning': _ctx.report.missingFields.length,
                    'badge--success': !_ctx.report.missingFields.length
                }]
      }, _toDisplayString(_ctx.report.missingFields.length), 11, ["title"])
    ]),
    _createVNode("div", null, [
      _hoisted_4,
      _createVNode("span", {
        class: ["badge badge--rounded", {
                    'badge--error': _ctx.report.matchConflicts.length,
                    'badge--success': !_ctx.report.matchConflicts.length
                }]
      }, _toDisplayString(_ctx.report.matchConflicts.length), 3)
    ])
  ]))
})